import { Component, inject } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ContactOriginService } from './contact-us.service';

@Component({
  selector: 'app-contact-success-modal',
  template: `
    <ion-header class="shadow-xs">
      <ion-toolbar class="modal-header">
        <h3>Your message was sent</h3>
        <ion-buttons slot="end">
          <ion-button role="button" class="text-base" (click)="dismiss()">
            <ion-icon name="close" aria-hidden="true"></ion-icon>
            Close
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="modal-content custom-modal">
      <div class="px-6">
        <h3 class="text-center"></h3>
        <p class="mt-2">Thank you for contacting the Young Stroke Service team.</p>
        <p>A team member will contact you soon.</p>
        <div class="mt-4 px-2">
          <ion-button
            role="button"
            class="mb-6"
            fill="solid"
            color="secondary"
            expand="block"
            shape="round"
            (click)="dismiss()"
          >
            Close
          </ion-button>
        </div>
      </div>
    </ion-content>
  `,
})
export class ContactSuccessModalComponent {
  private navCtrl = inject(NavController);
  constructor(private modalCtrl: ModalController, private contactService: ContactOriginService) {}

  dismiss() {
    const origin = this.contactService.getOrigin();
    if (origin === 'survey-help') {
      this.modalCtrl.dismiss();
      this.navCtrl.navigateRoot(['dashboard']);
      this.contactService.setOrigin('');
    } else {
      this.modalCtrl.dismiss();
    }
  }
}
